import { DateTime } from "luxon";

import { useClock } from "./useClock";

export function useTextingHours({
  start,
  end,
  timezone,
}: {
  start: string;
  end: string;
  timezone: string;
}): { isInTextingHours: boolean } {
  const now = useClock().setZone(timezone);
  const startTime = todayAtThisTime(start, timezone);
  const endTime = todayAtThisTime(end, timezone);

  return { isInTextingHours: now >= startTime && now <= endTime };
}

function todayAtThisTime(timeStr: string, tz: string): DateTime {
  const pieces = timeStr.split(":").map(bit => Number(bit));
  return DateTime.fromObject(
    {
      hour: pieces[0] || 0,
      minute: pieces[1] || 0,
      second: pieces[2] || 0,
    },
    { zone: tz }
  );
}
